import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { DonutBreakdownCard, BarBreakdownCard } from '../../../common/analytics';
import CardSkeleton from '../../../common/cardSkeleton/CardSkeleton';
import styles from './styles/payroll-connections-section.module.scss';

function PayrollConnectionsSection({ payrollHealth, payrollConnections, payrollLinkErrors, loading = false }) {
    return (
        <section className={styles.section}>
            <Text as="span" size="xs" className={styles.sectionLabel}>Payroll Connections</Text>
            {loading ? (
                <div className={styles.grid}>
                    <CardSkeleton minHeight={420} rows={6} />
                    <CardSkeleton minHeight={320} rows={5} />
                    <CardSkeleton minHeight={320} rows={5} />
                </div>
            ) : (
            <div className={styles.grid}>
                <DonutBreakdownCard
                    title={payrollHealth.title}
                    subtitle={payrollHealth.subtitle}
                    total={payrollHealth.total}
                    totalLabel={payrollHealth.totalLabel}
                    segments={payrollHealth.segments}
                />
                <BarBreakdownCard
                    title={payrollConnections.title}
                    subtitle={payrollConnections.subtitle}
                    items={payrollConnections.items}
                />
                <BarBreakdownCard
                    title={payrollLinkErrors.title}
                    subtitle={payrollLinkErrors.subtitle}
                    items={payrollLinkErrors.items}
                />
            </div>
            )}
        </section>
    );
}

export default PayrollConnectionsSection;
